<template>
  <div class="locations-and-cities">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Cities</h1></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="2-5"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-select @change="selectPage(1)" style="max-width: 200px" placeholder="Select Region"  class="mr-1" v-model="listParam.RegionID" filterable  clearable>
                <el-option v-for="item in regionList" :key="item.RegionID" :value="item.RegionID"
                           :label="decodeURI(item.RegionName)"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:20%" class="long-text">City Name</th>
                  <th style="width:65%" class="long-text">Region</th>
                  <th style="width:15%;vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center"  v-if="user.type >= 6">
                      <v-btn class="add-icon" @click="dialogVisible = true" dark>Add New</v-btn>
                    </div>
                  </th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="locations.length > 5 ? 'content-scroll-y' : ''"> -->
            <div>
              <table class="table">
                <tbody>
                <tr v-for="city in cities" :key="city.CityID">
                  <td style="width:20%" class="long-text">{{ decodeURI(city.CityName) }}</td>
                  <td style="width:65%" class="long-text">{{ decodeURI(city.RegionName) }}</td>
                  <td style="width:15%; vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center">
                      <img @click="currentObj=$_.cloneDeep(city); dialogVisible=true" data-toggle="tooltip" data-placement="right"
                           title="Edit City" src="@/assets/images/edit_icon.svg"/>
                      <img v-if="user.type >= 6" data-toggle="tooltip" data-placement="right"
                           title="Delete City" @click="showDelete(city)" src="@/assets/images/delete_icon.svg"/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
    <el-dialog
        class="edit-zoho-dialog"
        :title="currentObj.CityID ? 'Edit City' : 'Add City'"
        :visible.sync="dialogVisible"
        @close="closeModal"
        width="50%">
      <div>
        <el-form ref="ruleForm" :model="currentObj" label-width="110px" :rules="rules">
          <el-form-item label="City Name" prop="CityName">
            <el-input placeholder="City Name" v-model="currentObj.CityName" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="Region" prop="RegionID">
            <el-select class="w-100" v-model="currentObj.RegionID" filterable clearable placeholder="Select Region"
                       :loading="loadingSelect">
              <el-option v-for="item in regionList" :key="item.RegionID" :value="item.RegionID"
                         :label="decodeURI(item.RegionName)"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="dialogVisible = false">Cancel</v-btn>
    <v-btn dark :disabled="user.type < 6" :loading="loading" @click="submitForm('ruleForm')">Save</v-btn>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'

export default {
  name: 'AdminLocationsAndRegions',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    const cityNameValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('City Name is required.'))
        return
      }
      if (s.length > 32) {
        callback(new Error('City Name must not exceed 32 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('City Name must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s-]+$/.test(s)) {
        callback(new Error('City Name may only contain English letters, spaces, and hyphens (-).'))
        return
      }
      callback()
    }
    return {
      currentObj: {
        CityName: '',
        RegionID: null,
      },
      loadingSelect: false,
      regionList: [],
      rules: {
        CityName: [
          {validator: cityNameValidator, trigger: ['blur', 'change']},
        ],
        RegionID: [
          {required: true, message: 'Please select region', trigger: 'change'},
        ]
      },
      loading: false,
      cities: [],
      dialogVisible: false,
      totalCount: 0,
      listParam: {
        pageNum: 1,
        pageSize: 10,
        RegionID: null
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    closeModal() {
      this.$refs.ruleForm.resetFields()
      this.currentObj = {
        CityName: '',
        RegionID: null,
      }
    },
    showDelete(c) {
      this.$confirm({
        content: `Are you sure you wish to delete the city: ${c.CityName}?`,
        onConfirm: () => {
          utilities.deleteCitiesNew(c.CityID).then(() => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: '<div class="alert-success">' +
                  '            <b>Success:</b> City Deleted !' +
                  '          </div>',
            });
            this.selectPage(1)
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.currentObj.CityName = String(this.currentObj.CityName || '').trim()
          this.loading = true
          if (this.currentObj.CityID) {
            const param = {...this.currentObj}
            delete param.CityID
            delete param.RegionName
            utilities.putCityNew(this.currentObj.CityID, param).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> City Updated !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          } else {
            utilities.postCitiesNew(this.currentObj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> City Created !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.getData()
    },
    async getData() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const {data, count} = await utilities.getCitiesNew(this.listParam)
      this.cities = data
      this.totalCount = count
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  async beforeMount() {
    await this.getData()
    const {data} = await utilities.getRegionsNew({pageNum: 1, pageSize: 999})
    this.regionList = data
  },
  mounted() {
  },
}
</script>
